import enumBase from './EnumBase';

export default class EnvelopeTriggerEvent extends enumBase {
  static ENVELOPE_COMPLETED = 'ENVELOPE_COMPLETED';
}
